import { useEffect, useState } from "react";
import axios from "../../../axios";
import { fetchLatestVersion, runningVersion } from "../../../helpers/appVersion";
import * as styled from "./VersionsCard.styled";

const ROLES = { student: "учень", teacher: "вчитель", admin: "адмін", manager: "менеджер", "trial-student": "пробний" };
const when = (date) =>
  new Date(date).toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

// «Чи всі отримали оновлення»: хто за 7 днів заходив і на якій версії
function VersionsCard() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  // Остання версія — та, що зараз на сервері (свіжий index.html); якщо не вдалося — оцінка сервера
  useEffect(() => {
    // Спершу фіксуємо власну версію адміна, щоб він сам не потрапив у «ще не оновились»
    const mine = runningVersion();
    const reportMine = mine ? axios.post("client-version", { version: mine }).catch(() => {}) : Promise.resolve();
    reportMine
      .then(() => Promise.all([axios.get("client-versions", { params: { days: 7 } }), fetchLatestVersion().catch(() => null)]))
      .then(([{ data }, deployed]) => setData({ ...data, latest: deployed || data.latest }))
      .catch(() => setData(null));
  }, []);

  if (!data || !data.users.length) return null;
  const mine = runningVersion();
  const fresh = data.users.filter((user) => user.version === data.latest);
  const stale = data.users.filter((user) => user.version !== data.latest);
  const latestSince = fresh.length ? new Date(Math.min(...fresh.map((user) => new Date(user.since)))) : null;
  const percent = Math.round((fresh.length / data.users.length) * 100);

  return (
    <styled.Card>
      <styled.Title>🔄 Оновлення платформи</styled.Title>
      <styled.Summary>
        <b>{fresh.length}</b> з {data.users.length} користувачів (заходили за 7 днів) вже на останній версії
        {latestSince && <small> · перші оновились {when(latestSince)}</small>}
      </styled.Summary>
      <styled.Bar>
        <styled.Fill style={{ width: `${percent}%` }} />
      </styled.Bar>
      {mine && mine !== data.latest && <styled.Warn>У вас самих не остання версія — перезавантажте сторінку.</styled.Warn>}
      {stale.length > 0 && (
        <>
          <styled.Toggle type="button" onClick={() => setOpen((value) => !value)}>
            {open ? "Сховати" : `Ще не оновились: ${stale.length}`}
          </styled.Toggle>
          {open && (
            <styled.List>
              {stale.map((user) => (
                <styled.Row key={user.userId}>
                  <span>
                    {user.name || "—"} <small>{ROLES[user.userType] || user.userType}</small>
                  </span>
                  <small>був(ла) {when(user.seenAt)}</small>
                </styled.Row>
              ))}
            </styled.List>
          )}
        </>
      )}
      <styled.Hint>Старі версії оновлюються самі, щойно людина знову відкриє платформу.</styled.Hint>
    </styled.Card>
  );
}

export default VersionsCard;
